export default {
  data() {
    return {
      searchSchema: [
        {
          label: '货币',
          type: 'input',
          itemName: 'money',
          allowClear: true,
        },
        {
          label: '是否生效',
          type: 'select',
          itemName: 'useful',
          selectList: [
            { text: '是', value: 1 },
            { text: '否', value: 2 },
          ],
          allowClear: true,
        },
      ],
      searchForm: {
        useful: '',
        money: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          align: 'center',
          fixed: 'left',
          title: '序号',

          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '货币',

          dataIndex: 'money',
        },
        {
          title: '人民币',
          dataIndex: 'moneyName',
        },
        {
          title: '比例(货币:人民币)',
          align: 'center',
          width: 180,
          dataIndex: 'proportion',
        },
        {
          title: '是否生效',
          width: 120,
          align: 'center',
          dataIndex: 'usefulType',
        },
        {
          title: '创建人',
          width: 200,
          dataIndex: 'userName',
        },
        {
          title: '创建时间',
          width: 200,
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '操作',
          align: 'center',
          width: 120,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
